module.exports = __webpack_public_path__ + "img/pink-padlock-unlock.770b3070.svg";